export default "/images/img_12.png?d7aa5163962b3870b38c0b1b9586bcae";